import 'es6-promise/auto'
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import  App    from './App.vue';
import RootPane from './components/RootPane.vue';
import OntologyPane from './components/OntologyPane.vue';
import ConceptPane from './components/ConceptPane.vue';

import { createStore } from './store'

// We want to apply VueResource and VueRouter
// to our Vue instance
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
// Pointing routes to the components they should use

const router = new VueRouter({

  mode: 'history',
  routes: [
    { name: 'root', path: '/', component: RootPane },
    { name: 'rootPane', path: '/index.html', component: RootPane },
    { name: 'ontology', path: '/page/:ontology', component: OntologyPane },
    { name: 'concept', path: '/:type/:ontology/:concept*', component: ConceptPane },
  ]
})

let store = createStore()

/* eslint-disable no-new */
let main = new Vue({
  el: '#app',
  store: store,
  router: router,
  components: { App },
  // replace the content of <div id="app"></div> with App
  render: (h:any) => h(App),
  methods: {}
})

export default { main, router, store } 



// WEBPACK FOOTER //
// ./src/main.ts